import { render } from "./buildingList.vue?vue&type=template&id=465e6cc2"
import script from "./buildingList.vue?vue&type=script&lang=js"
export * from "./buildingList.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__